<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-10 mr-auto" *ngIf="loaded">
        <h3>{{contentData.name}} (ID: {{contentData.id}})</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col-2 ml-auto text-right">
    <button class="btn btn-outline-success text-dark font-weight-bold" (click)="openModal(newEpisodeModel)">+ New Episode</button> |
    <button class="btn btn-default" (click)="onBack()">Back</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="metaList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead class="text-center">
    <tr>
      <th>ID</th>
      <th>Name</th>
      <th>Content</th>
      <th>Description</th>
      <th>Created Time</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="15">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="15">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let episode of episodeList; index as i;" class="text-center">
      <td>{{episode.id}}</td>
      <td >{{episode.title}}</td>
      <td class="text-left">{{episode.content}}</td>
      <td class="text-left">{{episode.description}}</td>
      <td>{{episode.createdAt}}</td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/tx/episode-detail', episode.id]" >
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteEpisode(episode)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="15" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newEpisodeModel let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newEpisodeLabel">New Episode</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newEpisode-modal-body">
    <form [formGroup]="newEpisodeForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-10">
          <label for="title" class="col-form-label"><span class="text-danger">* </span>Title:</label>
          <input type="text" class="form-control" formControlName="title">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.title.errors">
                Title cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-10">
          <label for="content" class="col-form-label"><span class="text-danger">* </span>Content:</label>
          <input type="text" class="form-control" formControlName="content">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.content.errors">
                Content cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-10">
          <label for="description" class="col-form-label">Description:</label>
          <input type="text" class="form-control" formControlName="description">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
